<template>
  <div>
    <!-- 头部 -->
    <the-header backPath="/user/center" v-bind:balance="balance" v-bind:balanceShow="true"></the-header>

    <div>
      <div @click="popupVisible1 = true">
        <mt-cell
            title="选择省份"
            is-link
            :value="form.province">
        </mt-cell>
      </div>
      <div @click="popupVisible2 = true">
        <mt-cell
            title="选择城市"
            is-link
            :value="form.city_name">
        </mt-cell>
      </div>
      <mt-field placeholder="请输入车牌号" v-model="form.hphm"></mt-field>
      <mt-field :placeholder="'请输入发动机号后' + selectedCity.engineno + '位'" v-if="selectedCity.engineno != 0" v-model="form.engineno"></mt-field>
      <mt-field :placeholder="'请输入车架号后' + selectedCity.classno + '位'" v-if="selectedCity.classno != 0"  style="border-bottom: 1px solid #f2f2f2" v-model="form.classno"></mt-field>
      <mt-field placeholder="请输入完整发动机号" v-if="selectedCity.engineno == 0" v-model="form.engineno"></mt-field>
      <mt-field placeholder="请输入完整车架号" v-if="selectedCity.classno == 0"  style="border-bottom: 1px solid #f2f2f2" v-model="form.classno"></mt-field>
      <div class="hpzl-list">
        <div class="hpzl-item" @click="form.hpzl = '02'">
          <div>小型车</div>
          <input type="radio" value="02" v-model="form.hpzl"/>
        </div>
        <div class="hpzl-item" @click="form.hpzl = '01'">
          <div>大型车</div>
          <input type="radio" value="01" v-model="form.hpzl"/>
        </div>
      </div>
      <mt-popup
          class="wz-vux-picker"
          style="width: 100%"
          v-model="popupVisible1"
          position="bottom">
        <div style="text-align: right;padding: 10px" @click="popupVisible1 = false">确定</div>
        <mt-picker :slots="slots1" @change="onValuesChange1"></mt-picker>

      </mt-popup>
      <mt-popup
          class="wz-vux-picker"
          style="width: 100%"
          v-model="popupVisible2"
          position="bottom">
        <div style="text-align: right;padding: 10px" @click="popupVisible2 = false">确定</div>
        <mt-picker :slots="slots2" @change="onValuesChange2"></mt-picker>

      </mt-popup>
    </div>

    <!-- 底部操作 -->
    <div class="wx-bottom-operate-space"></div>
    <div class="wx-bottom-operate">
      <div class="operate-box operate-button" :class="form.hphm.length < 7 ? 'operate-button-disabled' : ''" @click="goToWeizhangDetail()">查询违章</div>
      <div class="operate-box operate-button operate-button-disabled" @click="clearForm" style="background: #fff;color: #545454">清除查询</div>
    </div>

  </div>
</template>

<script>
  import { Cell, Toast, Field, Picker, Popup } from 'mint-ui';
  import TheHeader from '@/components/TheHeader'

  export default {
    computed: {
    },
    components: {
      [Popup.name]:Popup,
      [Picker.name]:Picker,
      [Cell.name]:Cell,
      [Field.name]:Field,
      TheHeader
    },
    data () {
      return {
        popupVisible1: false,
        popupVisible2: false,
        balance: null,
        cityList: [],
        slots1: [
          {
            flex: 1,
            values: [],
            className: 'slot1',
            textAlign: 'center'
          }
        ],
        slots2: [
          {
            flex: 1,
            values: [],
            className: 'slot1',
            textAlign: 'center'
          }
        ],
        form: {
          province: '选择',
          city_name: '选择',
          city: '',
          hphm: '',
          hpzl: '02',
          engineno: '',
          classno: ''
        },
        selectedProvince: {},
        selectedCity: {engineno: '0', classno: '0'}
      }
    },
    watch: {
    },
    mounted () {
      this.pageInit()
    },
    methods: {
      pageInit() {
        this.fetchCitys()
        setTimeout(()=>{
          if (localStorage.getItem('rd_car_wz_info')) {
            this.form = JSON.parse(localStorage.getItem('rd_car_wz_info'))
          }
        },2000)

      },
      clearForm () {
        this.form = {
          province: '选择',
          city_name: '选择',
          city: '',
          hphm: '',
          hpzl: '02',
          engineno: '',
          classno: ''
        }
      },
      // 获取支持的城市
      fetchCitys () {
        let params = {}
        this.$api.goods.getWeizhangCitys(params).then((res) => {
          this.cityList = res.data.data
          for (let i = 0;i < this.cityList.length;i++) {
            this.slots1[0].values.push(this.cityList[i].province)
          }
          this.form.province = this.slots1[0].values[0]
        }).catch(err => {
          console.log(err)
        })
      },
      isLicensePlate(str) {
        return /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/.test(str);
      },
      // 跳转到违章详情
      goToWeizhangDetail () {
        if (this.form.province == '选择'&&this.form.city_name == '选择') {
          Toast("请选择省份与城市");
          return false
        }
        if (this.form.hphm == '') {
          Toast("请输入车牌号");
          return false
        } else {
          let r = this.isLicensePlate(this.form.hphm)
          if (r == false) {
            Toast("请输入正确的车牌号码");
            return false
          }
        }
        if (this.selectedCity.engine == 1&& this.form.engineno == '') {
          Toast("请输入发动机号");
          return false
        }
        if (this.selectedCity.class == 1&& this.form.classno == '') {
          Toast("请输入车架号");
          return false
        }
        localStorage.setItem('rd_car_wz_info', JSON.stringify(this.form));
        this.$router.push({ name: 'applyWeizhangDetail', params: this.form});
      },
      onValuesChange1(picker, values) {
        this.form.province = values[0]
        this.slots2[0].values = []
        for (let i = 0;i < this.cityList.length;i++) {
          if(values[0] == this.cityList[i].province) {
            this.selectedProvince = this.cityList[i]
            for (let j = 0;j < this.cityList[i].citys.length;j++) {
              this.slots2[0].values.push(this.cityList[i].citys[j].city_name)
            }
          }
        }
      },
      onValuesChange2(picker, values) {
        this.form.city_name = values[0]
        for (let i = 0;i < this.selectedProvince.citys.length;i++) {
          if(values[0] == this.selectedProvince.citys[i].city_name) {
            this.selectedCity = this.selectedProvince.citys[i]
            this.form.city = this.selectedCity.city_code
          }
        }

      },
      // 页面跳转
      goTo (path) {
        this.$router.push(path);
      },
      // 外部跳转
      goToUrl (url) {
        window.location.href = url + '?token=' + localStorage.getItem('token');
      },
      // 开发中
      unopen () {
        Toast("敬请期待...");
      }
    }
  };
</script>

<style lang="scss">
  @import "@/assets/css/my-mint.scss";
  body {
    background-color: #FFFFFF;
  }

  ::-webkit-input-placeholder { /* WebKit browsers */
    color: #666666;
  }
  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #666666;
  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #666666;
  }
  :-ms-input-placeholder { /* Internet Explorer 10+ */
    color: #CCCCCC;
  }

  .header-space {
    height: 110px;
  }

  .cost-exchange-content {
    padding: 22px 27px 43px 27px;
  }

  .exchange-content-navbar {
    padding: 27px 27px 43px 27px;
  }

  .wz-vux-picker {
    .picker{
      .picker-items {
        .picker-slot {
          .picker-slot-wrapper {
            .picker-item {
              font-size: 30px;
            }
          }
        }
      }
    }
  }

  .hpzl-list {
    margin-top: 50px;
    text-align: center;
    .hpzl-item {
      border: 2px solid #dbdbdb;
      border-radius: 10px;
      padding: 40px 20px;
      display: inline-block;
      width: 180px;
      margin: 0 30px;
      div {
        margin-bottom: 20px;
      }
    }
  }
  .exchange-form {
    padding: 0 27px 40px 27px;

    .cell-item {
      padding: 0 0 40px;
      height: 90px;

      label {
        padding: 0 20px 0 0;
        font-size: 26px;
      }
    }

    .input-item {
      margin: 0;
      padding: 0 35px 0 35px;
      border: 0;
      border-radius: 6px;
      width: 626px;
      height: 90px;
      line-height: 90px;
      font-size: 26px;
      background-color: #F0F0F0;
    }

    .contents-note {
      padding: 10px 6px 0 6px;
      line-height: 38px;
      font-size: 20px;
      color: #4A4A4A;

      .note-title {
        line-height: 40px;
        font-size: 22px;
      }
    }
  }

  .exchange-form-navbar {
    padding: 43px 27px 0 27px;

    .cell-item {
      padding: 0 0 0;
    }
  }


  .wx-bottom-operate-space {
    height: 107px;
  }

  .wx-bottom-operate {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 750px;
    height: 107px;
    background-color: #FFFFFF;

    .operate-box {
      width: 375px;
      height: 106px;
      float: left;
      text-align: center;
    }

    .operate-info {
      float: left;
      border-top: 1px solid #979797;

      .operate-title {
        padding: 13px 0 0 0;
        line-height: 52px;
        font-size: 32px;
      }

      .operate-describe {
        line-height: 28px;
        font-size: 20px;
        color: #4A4A4A;
      }
    }

    .operate-button {
      line-height: 106px;
      font-size: 32px;
      float: right;
      color: #FFFFFF;
      background-color: #000000;
      border-top: 1px solid #000000;
    }

    .operate-button-disabled {
      background-color: #BFBFBF;
      border-top: 1px solid #BFBFBF;
    }
  }
</style>
